import { Column } from "@/components/Datatable/types";
import { RosterManagementReportItem } from "../../api/fetchRosterManagementReport/types";

export function rosterManagementReportColumns(): Column<RosterManagementReportItem>[] {
  return [
    {
      header: "Company Name",
      accessorKey: "companyName",
      enableSorting: true,
      cell: ({ row }) => row.original.companyName,
    },
    {
      header: "Full Name",
      accessorKey: "fullName",
      enableSorting: true,
      cell: ({ row }) => row.original.fullName,
    },
    {
      header: "Event",
      accessorKey: "eventName",
      enableSorting: true,
      cell: ({ row }) => row.original.eventName,
    },
    {
      header: "Session Start Date",
      accessorKey: "sessionStartDate",
      enableSorting: true,
      cell: ({ row }) => row.original.sessionStartDate ?? "",
    },
    {
      header: "Session End Date",
      accessorKey: "sessionEndDate",
      enableSorting: true,
      cell: ({ row }) => row.original.sessionEndDate ?? "",
    },
    {
      header: "Retail Price",
      accessorKey: "retailPrice",
      enableSorting: true,
      cell: ({ row }) =>
        row.original.retailPrice ? `$${row.original.retailPrice}` : "",
    },
    {
      header: "Net Price",
      accessorKey: "netPrice",
      enableSorting: true,
      cell: ({ row }) =>
        row.original.netPrice ? `$${row.original.netPrice}` : "",
    },
    {
      header: "Description",
      accessorKey: "description",
      cell: ({ row }) => row.original.description,
    },
    {
      header: "Email",
      accessorKey: "email",
      cell: ({ row }) => row.original.email ?? "",
    },
  ];
}
